import { useBillingCycleSelect } from "@pallet/features/PartnershipTierType/BillingCycleSelector/hook"
import { Button } from "@pallet-hq/hegel"
import mixpanel from "mixpanel-browser"
import useOnboardingModal from "components/Modals/OnboardingModal/hook"
import { BUTTON_TYPES, TRACK_EVENTS } from "constants/events"
import useAuthContext from "state/useAuthContext"
import { usePalletRouter } from "utils/hooks/usePalletRouter"
import { NewPartnershipTierSelectorItemTierFragment } from "__generated__/NewPartnershipTierSelectorItemTierFragment"
import { NewPartnershipTierSelectorItemApplylistFragment } from "__generated__/NewPartnershipTierSelectorItemApplylistFragment"

type NewSubscribeButtonProps = {
    applylist: NewPartnershipTierSelectorItemApplylistFragment
    partnershipTier: NewPartnershipTierSelectorItemTierFragment
    referrer?: "jobs" | "talent"
}

export const NewSubscribeButton = (props: NewSubscribeButtonProps) => {
    const router = usePalletRouter()
    const { getItem } = useBillingCycleSelect()
    const item = getItem(props.partnershipTier)

    const { authed, loading: authLoading } = useAuthContext()
    const { showModal: showLoginModal, setRouteAfterSubmit } =
        useOnboardingModal()

    const handleClick = () => {
        mixpanel.track(TRACK_EVENTS.COLLECTIVE_TIER_SELECTED, {
            type: BUTTON_TYPES.SUBSCRIBE,
            applylist_slug: props.applylist.slug,
            subscription_length: item?.recurringEnum,
        })
        if (props.applylist.customHireLink) {
            return router.push(props.applylist.customHireLink)
        }
        if (!authed && !authLoading) {
            setRouteAfterSubmit({
                pathname: "/hire/setup",
                query: { item: item?.uuid },
            })
            return showLoginModal()
        }
        return router.push({
            pathname: "/hire/setup",
            query: { item: item?.uuid },
        })
    }

    return (
        <Button
            variant={
                props.partnershipTier.isHighlightedTier
                    ? "primary"
                    : "secondary"
            }
            size="small"
            mt="small"
            width="100%"
            onClick={handleClick}
            disabled={props.applylist.slug !== "cardealershipguy"}
        >
            {!!props.applylist.group && props.referrer === "talent"
                ? "Meet candidates"
                : "Post roles"}
        </Button>
    )
}
